/* eslint-disable react/jsx-no-bind */
import autobind from 'autobind-decorator';
import * as React from 'react';
import onClickOutside from 'react-onclickoutside';

import { ENTER_ESCAPE } from '../../constants/key-maps'
import { OpenArrowButton } from '../active-button';
import HotKeys from '../hot-keys'
import { Text } from '../texts';
import { DropdownList } from './dropdown-list';
import { Styled } from './styled';

class SearchSelectionComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isDropdownOpen: false, inputString: '' };
  }

  closeDropdown = () =>
    this.setState({ isDropdownOpen: false, inputString: '' });

  render() {
    const {
      header,
      elements,
      activeElementIndexes,
      tooltips,
      disabled,
      backgroundColor,
      borderRadius,
      maxItemsAmount = 5,
      placeholder = 'Start typing',
    } = this.props;
    const activeElements = activeElementIndexes.map((index) => elements[index]);
    const searchQuery = this.state.inputString.toLowerCase();
    const filteredElements = elements.filter((el) => el.toLowerCase().indexOf(searchQuery) > -1);
    const creationEnabled = this.isCreationEnabled(filteredElements);
    return (
      <Styled.DropDownContainer
        borderRadius={borderRadius}
        disabled={disabled}
        backgroundColor={backgroundColor}
        withHeader={header}
        isDropdownOpen={this.state.isDropdownOpen}
        onClick={() =>
          !this.state.isDropdownOpen && this.setState({ isDropdownOpen: true })
        }
      >
        <HotKeys
          keyMap={ENTER_ESCAPE}
          handlers={{ escape: this.closeDropdown, enter: this.onEnter }}
        >
        <Styled.SelectedContent>
          <Styled.TextsContainer withHeader={header}>
            {header && (
              <Styled.Header
                value={activeElements.length || this.state.isDropdownOpen}
              >
                {header}
              </Styled.Header>
            )}
            {this.state.isDropdownOpen ? (
              <Styled.SearchInput
                placeholder={placeholder}
                onChange={(e) => this.setState({ inputString: e.target.value })}
                autoFocus={true}
              />
            ) : (
              !!activeElements.length && (
                <Text color="mainFont">{activeElements.join(', ')}</Text>
              )
            )}
          </Styled.TextsContainer>
          <OpenArrowButton
            isOpen={this.state.isDropdownOpen}
            onClick={() => this.state.isDropdownOpen && this.closeDropdown()}
          />
        </Styled.SelectedContent>
        {this.state.isDropdownOpen && (
          <DropdownList
            borderRadius={borderRadius}
            elements={elements}
            filteredElements={filteredElements}
            activeElements={activeElements}
            maxItemsAmount={maxItemsAmount}
            tooltips={tooltips}
            onClick={this.onItemClick}
            forceShowChildren={creationEnabled}
          >
            <Styled.CreateItem onClick={this.createNewItem}>
              <Styled.Label>
                <Text fontSize={12}>Create</Text>
              </Styled.Label>
              <Text withEllipsis={true}>{this.state.inputString}</Text>
            </Styled.CreateItem>
          </DropdownList>
        )}
        </HotKeys>
      </Styled.DropDownContainer>
    );
  }

  @autobind
  createNewItem() {
    this.props.onCreate(this.state.inputString);
    this.closeDropdown();
  }

  @autobind
  onItemClick(event, index) {
    const searchQuery = this.state.inputString.toLowerCase();
    if (searchQuery) {
      const filteredElements = this.props.elements.filter((el) => el.toLowerCase().indexOf(searchQuery) > -1);
      const selectedElement = filteredElements[index];
      const indexSelectedElement = this.props.elements.indexOf(selectedElement);
      this.props.onClick(indexSelectedElement);
    } else {
      this.props.onClick(index);
    }
    this.props.closeAfterClick && this.closeDropdown();
  }

  isCreationEnabled(elements) {
    const searchQuery = this.state.inputString.toLowerCase();
    return this.props.onCreate && !!searchQuery && !elements.find(el => el.toLowerCase() === searchQuery);
  }

  @autobind
  onEnter() {
    const creationEnabled = this.isCreationEnabled(this.props.elements);
    if (creationEnabled) {
      this.createNewItem();
    }
  }

  handleClickOutside = () => this.closeDropdown();
}

export const SearchSelection = onClickOutside(SearchSelectionComponent);
